import { neverHere } from "../tsHelpers";

export const asArray = () => [
  LocationType.Region,
  LocationType.Country,
  LocationType.Destination,
  LocationType.Airport,
];

export const toFriendlyName = (locationType: LocationType) => {
  switch (locationType) {
    case LocationType.Region:
      return "Region";
    case LocationType.Country:
      return "Country";
    case LocationType.Destination:
      return "Destination";
    case LocationType.Airport:
      return "Airport";
    default:
      neverHere(locationType);
  }
};
